var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4473 19.8621H16.5508L22.5094 26.8211V31.6322L25.4887 33.1034V26.8211L31.4473 19.8621Z",
    fill: "#17A1FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterActive);
export default __webpack_public_path__ + "static/media/filter-active.a72eb76847798075884fb7900bb215ab.svg";
export { ForwardRef as ReactComponent };